export class TermsOfUse{
    id:string;
    termsOfUseText:string;
    version:number;
    publishedOn:string;
}


// WEBPACK FOOTER //
// ./src/app/modules/admin-terms-of-use/entities/termsofuse.ts